export enum BadgeType {
  TECHSTARS_COMPANY = 'techstars-company',
  GLOBAL_NETWORK_PARTNER = 'global-network-partner',
  CATEGORY = 'category',
}

export enum BadgeLayout {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export interface BadgeConfig {
  type: BadgeType
  label: string
  backgroundColor: string
  textColor: string
  fontWeight: number
}

export interface PerkBadgeProps {
  type: BadgeType
  label: string
}

type BaseBadgesProps = {
  isTechstarsCompany?: boolean
  isGlobalNetworkPartner?: boolean
  categories?: string[]
  layout?: BadgeLayout
}

/**
 * Props for PerkBadges component that ensures at least one badge type is provided.
 *
 * This type allows multiple badge types to be displayed simultaneously while preventing
 * empty objects from being passed. At least one of the following must be provided:
 * - isTechstarsCompany (boolean)
 * - isGlobalNetworkPartner (boolean)
 * - categories (string array)
 *
 * Valid examples:
 * - { isTechstarsCompany: true }
 * - { categories: ['software'] }
 * - { isTechstarsCompany: true, isGlobalNetworkPartner: false, categories: ['fintech'] }
 *
 * Invalid: {} (empty object)
 */
export type PerkBadgesProps = BaseBadgesProps &
  (
    | { isTechstarsCompany: boolean }
    | { isGlobalNetworkPartner: boolean }
    | { categories: string[] }
  )
